import { UsersApiService } from '../../common/services/users.api.service';
import { UserPasswordsApiService } from '../../common/services/user-passwords.api.service';
import { UserModel } from '../../common/models/user.model';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
    total: 0,
    storeData: null,
  },
  getters: {
    getAllUsers: state => state.items,
    getTotal: state => state.total,
    getStatus: state => state.status,
    getUser: state => id => state.items.find(item => item.id === id),
    getStoreData: state => state.storeData,
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_ITEM(state, data) {
      const arrayIndex = state.items.findIndex(item => item.id === data.id);

      if (arrayIndex === -1) {
        state.items.push(data);
      } else {
        this.$app.$set(state.items, arrayIndex, data);
      }
    },
    REMOVE_ITEM(state, id) {
      const arrayIndex = state.items.findIndex(item => item.id === id);

      if (arrayIndex !== -1) {
        state.items.splice(arrayIndex, 1);
      }
    },
    SET_TOTAL(state, data) {
      state.total = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
    SET_STORE_DATA(state, payload) {
      state.storeData = payload;
    },
  },
  actions: {
    fetchAllUsers({ commit, dispatch }, { options, searchQuery }) {
      commit('FETCH_REQUEST');

      return UsersApiService.getAll(builder => {
        if (options) {
          builder.getPage(options.page);
          builder.getPerPage(options.itemsPerPage);
          if (options.sortDesc[0]) {
            builder.sortBy(options.sortBy);
          } else {
            builder.sortByDesc(options.sortBy);
          }
        }

        if (searchQuery) {
          builder.whereContains([UserModel.ATTR_FIRST_NAME, UserModel.ATTR_LAST_NAME], searchQuery.trim());
        }

        builder.embed([UserModel.EMBED_ROLE_IDS]);
      })
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('SET_TOTAL', response.getMeta().records);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    fetchUser({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return UsersApiService.get(id, builder => {
        builder.embed([UserModel.EMBED_ROLE_IDS]);
      })
        .then(response => {
          commit('SET_ITEM', response.getItem());
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    updateUser({ commit, dispatch }, { id, formData }) {
      commit('FETCH_REQUEST');

      return UsersApiService.patch(id, formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response.getItem());
          return response.getItem().id;
        })
        .catch(response => {
          dispatch('handleError', response);
          return Promise.reject();
        });
    },

    setStoreData({ commit }, data) {
      commit('SET_STORE_DATA', data);
    },

    updateUserPassword({ commit, dispatch }, { id, formData }) {
      commit('FETCH_REQUEST');

      return UserPasswordsApiService.put(id, formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          commit('SET_ITEM', response.getItem());
        })
        .catch(response => {
          dispatch('handleError', response);
          return Promise.reject();
        });
    },

    createUser({ commit, dispatch }, formData) {
      commit('FETCH_REQUEST');

      return UsersApiService.post(formData)
        .then(response => {
          commit('FETCH_SUCCESS');
          return response.getItem().id;
        })
        .catch(response => {
          dispatch('handleError', response);
          return Promise.reject();
        });
    },

    deleteUser({ commit, dispatch }, id) {
      commit('FETCH_REQUEST');

      return UsersApiService.delete(id)
        .then(() => {
          commit('FETCH_SUCCESS');
          commit('REMOVE_ITEM', id);
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
